import { NotificationSeverity, NotificationSource, NotificationModel, NotificationRaw } from '../models';

export function convertSourceIntoIcon(source: NotificationSource) {
  switch (source) {
    case 'ROSTR': {
      return 'dashboard';
    }
    case 'VACAY': {
      return 'airplanemode_active';
    }
    case 'ARGUS': {
      return 'camera';
    }
    case 'AGENDA': {
      return 'event_available';
    }
    case 'AVAI': {
      return 'build';
    }

    default: {
      const exhaustiveCheck: never = source;
      throw new Error(exhaustiveCheck);
    }
  }
}

export function convertSeverityIntoColor(severity: NotificationSeverity) {
  switch (severity) {
    case 'ERROR': {
      return 'red';
    }
    case 'WARNING': {
      return 'orange';
    }
    case 'SUCCESS': {
      return 'green';
    }
    case 'NORMAL': {
      return 'blue';
    }
    case 'INFO': {
      return 'gray';
    }
    default: {
      const exhaustiveCheck: never = severity;
      throw new Error(exhaustiveCheck);
    }
  }
}

export function convertNotificationRawToModel(n: NotificationRaw): NotificationModel {
  return {
    id: n.id,
    source: n.source,
    eventName: n.eventName,
    content: n.content,
    severity: n.severity,
    link: n.link,
    isRead: n.notificationEmployees?.[0]?.isRead ?? false,
    createdAt: new Date(n.createdAt)
  };
}
